<div class="container">
	<div *ngIf="!logoAsset" class="logo-wrapper" [style.transform]="transformRules">
		<img class="logo" [src]="'./assets/SP Arrow (Blue-Gray).svg' | resolveAsset" [alt]="altText" />
	</div>
	<div *ngIf="logoAsset" class="logo-wrapper" [style.transform]="transformRules">
		<img height="24" [src]="logoAsset | resolveAsset" [alt]="altText" />
	</div>
</div>
